<template>
  <StepBackButton v-if="step === 'password'" class="pb-2" @back="goBackTo" />
  <h1 class="w-full text-2xl sm:text-3xl font-bold text-center sm:px-20 mb-8">
    {{ $t(`${trPrefix}registerHeading`) }}
  </h1>
  <transition
    :name="step === 'email' ? 'slide-right' : 'slide-left'"
    mode="out-in"
  >
    <RegisterFormEmail
      v-if="step === 'email'"
      @submit="updateEmailAndSubscription"
    />
    <RegisterFormPassword
      v-else
      :email
      @registered="goToVerification"
      @back="goToStep"
    />
  </transition>

  <UserAgreement class="mb-8" />

  <WebccOrDivider :with-text="true" class="mb-6" />

  <SocialSignUps class="mb-6" />

  <span class="text-xl mt-auto text-center">
    {{ $t(`${trPrefix}haveAccount`) }}
    <span
      class="text-thm hover:underline font-bold hover:cursor-pointer"
      @click="goToSignin"
    >
      {{ $t(`${trPrefix}goToSignIn`) }}
    </span>
  </span>
</template>

<script lang="ts" setup>
const trPrefix = 'components.auth.register.registerForm.'

const emit = defineEmits<{
  goTo: [value: AuthFlowType]
  isReady: []
}>()

const { getErrorMessage } = useAuthError(trPrefix)
const route = useRoute()
const auth = useAuthStore()
const tracking = useTracking()

const email = ref('')
const step = ref<RegisterStep>('email')
const completed = ref(false)
const errorMessage = ref<string>()

await initRegisterFlow()

onMounted(() => {
  emit('isReady')
})

function goToSignin() {
  emit('goTo', 'signIn')
}

function goBackTo() {
  step.value = 'email'
}

function goToStep(newStep: RegisterStep) {
  step.value = newStep
}

function goToVerification(success: boolean) {
  completed.value = success

  if (!success) return

  tracking.handlers?.auth.register()
  emit('goTo', 'verification')
}

function updateEmailAndSubscription(newEmail: string) {
  email.value = newEmail
  step.value = 'password'
}

async function initRegisterFlow() {
  if (!import.meta.client) return

  try {
    await auth.registerStart(route.fullPath)
  } catch (error) {
    errorMessage.value = getErrorMessage(error)
  }
}
</script>
